import { FC } from "react";

import useAdminCompanyConfig, { Props } from "./hook";
import { Styles } from "./styled";
import { Button } from "antd";
import TableConfigTax from "./components/TableConfigTax";
import CategoryStatusConfig from "./components/CategoryStatusConfig";

const CompanyConfigLayout: FC<Props> = ({
  uploadingInfo,
  timeUploaded,
  handleUploadSeed,
  handleUploadAccountTitles,
  displaySize,
  height,
  size,
}) => {
  return (
    <Styles text_scale={displaySize}>
      {/* <div className="header">
        <h2>管理者設定</h2>
      </div> */}
      <h2 className="title-button">労務シードデータ更新</h2>
      <div className="upload-file-config">
        <Button
          className="upload-file-config-button"
          loading={uploadingInfo.importTaxConfig.uploading}
          style={{
            fontSize: size,
            height: `${height}px`,
            width: "fit-content",
          }}
        >
          <label htmlFor="fileInput-1">
            <input
              onChange={(e) => handleUploadSeed(e)}
              id="fileInput-1"
              name="file-1"
              type="File"
              accept={
                ".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsm"
              }
              style={{ display: "none" }}
            />
            アップロード
          </label>
        </Button>
        {timeUploaded.importTaxConfig && (
          <label className="preview-file-inf">
            前回 : {timeUploaded.importTaxConfig} 更新成功
          </label>
        )}
      </div>

      <h2 className="title-button">勘定科目</h2>
      <div className="upload-file-config">
        <Button
          className="upload-file-config-button"
          loading={uploadingInfo.accountTitles.uploading}
          style={{
            fontSize: size,
            height: `${height}px`,
            width: "fit-content",
          }}
        >
          <label htmlFor="fileInput-2">
            <input
              onChange={(e) => handleUploadAccountTitles(e)}
              id="fileInput-2"
              name="file-2"
              type="File"
              accept={
                ".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsm"
              }
              style={{ display: "none" }}
            />
            アップロード
          </label>
        </Button>
        {timeUploaded.accountTitles && (
          <label className="preview-file-inf">
            前回 : {timeUploaded.accountTitles} 更新成功
          </label>
        )}
      </div>
      <TableConfigTax />

      <CategoryStatusConfig />
    </Styles>
  );
};

const CompanyConfig: FC = () => (
  <CompanyConfigLayout {...useAdminCompanyConfig()} />
);

export default CompanyConfig;
